<template>
  <div>
    <v-app-bar id="home-app-bar" app color="white" elevation="1" height="130">
      <base-img
        :src="require('@/assets/Julibee_Logo.png')"
        contain
        max-width="150"
        width="100%"
      />
      <div>
        <h2>Julibee Employment Pte Ltd</h2>

        <h5>License No.: 23C1569</h5>
      </div>
      <v-spacer />

      <div>
        <v-tabs class="hidden-sm-and-down" optional>
          <v-tab
            to="/"
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
          >
            Home
          </v-tab>

          <v-tab
            to="/about-us"
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
          >
            About Us
          </v-tab>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-tab
                active-class="text--primary"
                class="font-weight-bold"
                min-width="96"
                v-bind="attrs"
                v-on="on"
              >
                Services
              </v-tab>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-title>
                  <v-tab to="/confinement-nanny">
                    Confinement Nanny
                  </v-tab>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  <v-tab to="/domestic-helper">
                    Domestic Helper
                  </v-tab>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  <v-tab to="/local-helper-caregiver">
                    Local Helper & Caregiver
                  </v-tab>
                </v-list-item-title>
              </v-list-item>

              <v-list-item>
                <v-list-item-title>
                  <v-tab to="/confinement-herbs-package-meals">
                    Confinement Herbs Package / Meals
                  </v-tab>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-tab
            to="/testimonial"
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
          >
            Testimonials
          </v-tab>

          <v-tab
            to="/contact-us"
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
          >
            Contact Us
          </v-tab>
        </v-tabs>
      </div>

      <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer" />
    </v-app-bar>

    <home-drawer v-model="drawer" :items="items" />
  </div>
</template>

<script>
export default {
  name: "HomeAppBar",

  components: {
    HomeDrawer: () => import("./Drawer")
  },

  data: () => ({
    drawer: null
  })
};
</script>

<style lang="sass">
#home-app-bar
  .v-tabs-slider
    max-width: 24px
    margin: 0 auto

    .v-tab
      &::before
        display: none
</style>
